

export class RppConstants {

    public static readonly REMOTE_CONTROL_WS_PREFIX = "/remote-control";

}
